import {Navigate, Route, Routes,} from "react-router-dom";

import {useStore} from "./helpers/store";
import React, {lazy, Suspense, useEffect} from "react";
import configApp from "./config.json";

const App = () => {
  const user = useStore((state) => state.user);
  useStore((state) => state.setLanguage);
  useStore((state) => state.setLoading);
  function checkUser() {
    return !!user?.token;
  }

  useEffect(() => {
    setTheme();
  }, []);

  function setTheme() {
    let ConfigApp = (key) => configApp[process.env.REACT_APP_ID][key];

    document.title = ConfigApp("title");

    let favicon = ConfigApp("favicon");
    let link = document.querySelector('link[rel="icon"]');
    link.setAttribute("href", favicon);

    let theme = ConfigApp("theme");
    document.documentElement.style.setProperty(
      "--var-font-primary",
      "https://fonts.googleapis.com/css2?family=Lato:wght@400&display=swap"
    );
    document.documentElement.style.setProperty(
      "--var-color-primary",
      theme["color-primary"]
    );
    document.documentElement.style.setProperty(
      "--var-color-primary-dark",
      theme["color-primary-dark"]
    );
    document.documentElement.style.setProperty(
      "--var-color-primary-light",
      theme["color-primary-light"]
    );
    document.documentElement.style.setProperty(
      "--var-color-white",
      theme["color-white"]
    );
    document.documentElement.style.setProperty(
      "--var-color-black",
      theme["color-black"]
    );
    document.documentElement.style.setProperty(
      "--var-color-text-primary",
      theme["color-text-primary"]
    );
  }

  const LoginPage = lazy(() => import("./pages/login-page"));
  const MainPage = lazy(() => import("./pages/main-page"));
  const SummaryPage = lazy(() => import("./pages/summary-page"));
  const SuccessPage = lazy(() => import("./pages/success-page"));

  return (
    <Suspense>
      <Routes>
        <Route path="/:icAppToken" element={<LoginPage />} />
        <Route path="/" element={!checkUser() ? <LoginPage /> : <MainPage />} />
        <Route
          path="/summary"
          element={
            checkUser() ? <SummaryPage /> : <Navigate replace to={"/"} />
          }
        />
        <Route
          path="/success"
          element={
            checkUser() ? <SuccessPage /> : <Navigate replace to={"/"} />
          }
        />
        <Route path="*" element={<Navigate replace to={"/"} />} />
      </Routes>
    </Suspense>
  );
};

export default App;
